<template>
    <el-card>
        <div slot="header">
            <span class="top_title">BOM清单</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips">日期:</span>
                <el-date-picker
                    v-model="searchDate.dateRan"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
            <div class="search">
                <span class="searchtips">商品编号:</span>
                <el-input v-model="searchDate.number" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <span class="searchtips">商品名称:</span>
                <el-input v-model="searchDate.name" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <span class="searchtips">备注:</span>
                <el-input v-model="searchDate.remark" placeholder="" style="width: 160px;"></el-input>
            </div>
            <div class="search">
                <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            "
            border
        >
            <el-table-column label="操作" width="200px" align="center">
                <template slot-scope="{row}">
                    <el-button type="text" @click="edit(row.id)">查看BOM清单</el-button>
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
                <template v-if="col.show">
                    <el-table-column :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                        <template #header v-if="col.column">
                            {{col.label}}
                            <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                        </template>
                        <template slot-scope="{ row }">
                            <template v-if="col.prop=='valid'||col.prop=='normal'">
                                <template>
                                    <div>{{row[col.prop]==1?'是':'否'}}</div>
                                </template>
                            </template>
                            <template v-else-if="col.prop=='specs'">
                                <template>
                                    <el-popover
                                        placement="bottom"
                                        width="400"
                                        trigger="click"
                                        >
                                        <el-table :data="row.specs" border max-height="300">
                                            <el-table-column label="颜色" prop="color" align="left"></el-table-column>
                                            <el-table-column label="尺寸" prop="size" align="left"></el-table-column>
                                            <el-table-column label="包装数量" prop="unit" align="left"></el-table-column>
                                            <el-table-column label="价格" prop="price" align="left"></el-table-column>
                                        </el-table>
                                        <div slot="reference" style="color:#409EFF;cursor: pointer;">
                                            <i class="el-icon-view"> 查看</i>
                                            
                                        </div>
                                    </el-popover>
                                </template>
                            </template>
                            <template v-else>
                                <div>{{row[col.prop]}}</div>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </template>
        </el-table>
            <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="cp_pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        >
        </el-pagination>
        <el-dialog
            :visible.sync="mOrderEnterDialog"
            title="bom清单"
            width="90%"
        >
            <div class="searchItem">
                <div class="search">
                    <span class="searchtips">商品:{{enterName}}</span>
                </div>
                <div class="search">
                    <span class="searchtips">规格:</span>
                    <el-select v-model="specId" style="width:160px" @change="changeSelect">
                        <el-option v-for="item in specList" :key="item.id" :value="item.id" :label="item.label"></el-option>
                    </el-select>
                </div>
            </div>
            
            <SPTable ref="spt" :cols='cols2' :structure="structure" @returnData="saveEnter" :productModel="false" :wareHouseModel="false" :mproductModel="true"></SPTable>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" 
                    @click="submit()">保存入库</el-button
                >
                <el-button @click="mOrderEnterDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import SPTable from '../../components/table-column/supertable';
export default {
    components:{
        SPTable,
    },
    data(){
        return{
            searchDate: {
                dateRan: "",
                number:"",
                remark:"",
                name:"",
                column:'',
				order:'',
            },
            mOrderEnterDialog:false,
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            cols:[
            {
                prop: 'number',
                label: '商品编号',
                width: 160,
                show: true,
                align:'left',
            },{
                prop: 'name',
                label: '商品名称',
                width: 160,
                show: true,
                align:'left',
            },{
                prop: 'unit',
                label: '包装单位',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'price',
                label: '批发价(元)',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'specs',
                label: '辅助属性',
                width: 90,
                show: true,
                align:'left',
            },{
                prop: 'remark',
                label: '备注',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'valid',
                label: '是否启用',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'normal',
                label: '是否常用',
                width: '',
                show: true,
                align:'left',
            }],
            cols2:[
                {
                    prop: "name",
                    label: "产品",
                    edit:'mproductEdit',
                    type: "mproductEdit",
                    width: 240,
                },
                {
                    prop: "unit",
                    label: "单位",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "use",
                    label: "应用部位",
                    edit:'remarkEdit',
                    type: "remarkEdit",
                    width: 130,
                },
                {
                    prop: "price",
                    label: "单价(元)",
                    edit:'priceEdit',
                    type: "priceEdit",
                    width: 130,
                },
                {
                    prop: "count",
                    label: "数量",
                    edit:'countEdit',
                    type: "unknowNumCLEdit",
                    width: 130,
                    maxValue:'maxValue'
                },
                {
                    prop: "tprice",
                    label: "总价(元)",
                    edit:'',
                    type: "tpriceEdit",
                    width: 130,
                    cal1:'price',
                    cal2:'count',
                },
            ],
            tableData:[],
            total:0,
            currentPage:1,
            cp_pagesize:20,
            specList:[],
            nowSearch:{
                limit:20,
                page:1,
            },
            enterName:"",
            enterId:"",
            specId:"",
        }
    },
    created(){
        this.getInfo();
    },
    methods: {
        structure(){
            let obj = {
                id:0,
                pid: '',
                spid:'',
                count: 0,
                name:'',
                unit:'',
                use:'',
                maxValue:0,
                price:0,
                tprice:'',
                inter:'',
                spkey:'',
                countEdit:false,
                priceEdit:false,
                mproductEdit:false,
                remarkEdit:false,

            }
            return obj;
        },
        submit(){
            this.$refs.spt.getData();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.nowSearch.column = this.searchDate.column;
                this.nowSearch.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        saveEnter(formData){
            let obj = {
                pid:this.enterId,
                spid:this.specId,
            }
            let data = [];
            formData.forEach(e=>{
                if(e.count>0&&e.price>0&&e.use.length>0){
                    let ob = {
                        mid:e.pid,
                        msid:e.spid,
                        amount:e.count,
                        price:e.price,
                        use:e.use,
                    }
                    if(e.spkey>0){
                        ob.id = e.spkey;
                    }
                    data.push(ob);
                }
            })
            if(data.length>0){
                obj.data = JSON.stringify(data);
                this.$api.editBillMenu(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "BOM清单",
                            message: "编辑成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.mOrderEnterDialog = false;
                        this.getInfo();
                    }
                })
            }else{
                this.$common.error('没有完整的数据');
            }
        },
        changeSelect(){
            let obj = {
                pid:this.enterId,
                spid:this.specId,
            }
            this.$api.getProductSpecBill(obj).then(res=>{
                if(res.data.code==1){
                    this.$nextTick(()=>{
                        this.$refs.spt.getMProduct("",3);
                        this.$refs.spt.setData(res.data.data,(o,e)=>{
                            o.spkey = e.id;
                            o.pid = e.mid;
                            o.spid = e.msid;
                            o.price = e.price;
                            o.count = e.amount;
                            o.name = e.number +' ' +e.name;
                            o.use = e.use;
                            o.unit = e.packing;
                            o.inter = e.inter;
                            o.maxValue = 9999999;
                        })
                    })
                }
            })
        },
        searchOrder(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.nowSearch.start = this.searchDate.dateRan[0];
                this.nowSearch.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.number.length>0){
                this.nowSearch.number = this.searchDate.number;
            }
            if(this.searchDate.name.length>0){
                this.nowSearch.name = this.searchDate.name;
            }
            if(this.searchDate.remark.length>0){
                this.nowSearch.remark = this.searchDate.remark;
            }
            this.sortTime();
        },
        getInfo(){
            this.$api.listProductW(this.nowSearch).then(res=>{
                if(res.data.code==1){
                    this.tableData = res.data.data;
                    this.total = res.data.count;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
        edit(id){
            let obj = {
                pid:id,
                page:1,
                limit:-1,
            }
            this.$api.getProductBill(obj).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data.product;
                    this.enterId = id;
                    this.specId = "";
                    this.enterName = "["+info.pnumber+"]"+info.pname;
                    this.specList = [];
                    info.specs.forEach(e=>{
                        let obj = {
                            id:e.id,
                            label:e.color+"/"+e.size,
                        }
                        this.specList.push(obj);
                    })
                    this.mOrderEnterDialog = true;
                    this.$nextTick(()=>{
                        this.$refs.spt.clearAll();
                    })
                }
            })
        },
    }
}
</script>